export var MessageTypes = /* @__PURE__ */ ((MessageTypes2) => {
  MessageTypes2["NEGATIVE"] = "negative";
  MessageTypes2["POSITIVE"] = "positive";
  MessageTypes2["NEUTRAL"] = "neutral";
  MessageTypes2["INFO"] = "info";
  MessageTypes2["WARNING"] = "warning";
  return MessageTypes2;
})(MessageTypes || {});
export var ReliabilityActions = /* @__PURE__ */ ((ReliabilityActions2) => {
  ReliabilityActions2["REPORT"] = "report";
  ReliabilityActions2["CHARGE"] = "charge";
  ReliabilityActions2["RATING"] = "rating";
  return ReliabilityActions2;
})(ReliabilityActions || {});
export var DrawerTabs = /* @__PURE__ */ ((DrawerTabs2) => {
  DrawerTabs2["INFO"] = "info";
  DrawerTabs2["CONNECTORS"] = "connectors";
  DrawerTabs2["REVIEWS"] = "reviews";
  DrawerTabs2["ASSISTANCE"] = "assistance";
  return DrawerTabs2;
})(DrawerTabs || {});
export var DrawerView = /* @__PURE__ */ ((DrawerView2) => {
  DrawerView2["Preview"] = "preview";
  DrawerView2["Prices"] = "prices";
  DrawerView2["Simulator"] = "simulator";
  DrawerView2["VehicleSelection"] = "vehicle-selection";
  DrawerView2["ConnectorSelection"] = "connector-selection";
  DrawerView2["Filters"] = "filters";
  DrawerView2["RoutePlanner"] = "route-planner";
  DrawerView2["PoolList"] = "pool-list";
  return DrawerView2;
})(DrawerView || {});
export var DrawerPoolActions = /* @__PURE__ */ ((DrawerPoolActions2) => {
  DrawerPoolActions2["OPEN_PRICES"] = "open_prices";
  DrawerPoolActions2["ADD_COMMENT"] = "add_comment";
  DrawerPoolActions2["ADD_PHOTOS"] = "add_photos";
  DrawerPoolActions2["MODIFY_ZONE"] = "modify_zone";
  DrawerPoolActions2["SEND_TO_GPS"] = "send_to_gps";
  DrawerPoolActions2["COPY_ADDRESS"] = "copy_address";
  DrawerPoolActions2["COPY_COORDINATES"] = "copy_coordinates";
  return DrawerPoolActions2;
})(DrawerPoolActions || {});
export var ClipboardCopyActions = /* @__PURE__ */ ((ClipboardCopyActions2) => {
  ClipboardCopyActions2["ADDRESS"] = "address";
  ClipboardCopyActions2["COORDINATES"] = "coordinates";
  return ClipboardCopyActions2;
})(ClipboardCopyActions || {});
export var PoolWizardTabs = /* @__PURE__ */ ((PoolWizardTabs2) => {
  PoolWizardTabs2["LOCATION"] = "location";
  PoolWizardTabs2["ACCESS"] = "access";
  PoolWizardTabs2["CONNECTORS"] = "connectors";
  PoolWizardTabs2["OWNER"] = "owner";
  PoolWizardTabs2["INFORMATION"] = "information";
  PoolWizardTabs2["PHOTOS"] = "photos";
  return PoolWizardTabs2;
})(PoolWizardTabs || {});
export var VehicleManagementView = /* @__PURE__ */ ((VehicleManagementView2) => {
  VehicleManagementView2["LIST"] = "list";
  VehicleManagementView2["FORM"] = "form";
  VehicleManagementView2["DELETE"] = "delete";
  return VehicleManagementView2;
})(VehicleManagementView || {});
export var PoolListPanelType = /* @__PURE__ */ ((PoolListPanelType2) => {
  PoolListPanelType2["NEARBY"] = "nearby";
  PoolListPanelType2["FAVORITES"] = "favorites";
  return PoolListPanelType2;
})(PoolListPanelType || {});
